import { NudosSearchbarDropdown } from '../../../../NudosComponents';
import { CONFIG_CLASS_ID } from '../../../../../types/product.configuration.types';
import { CONFIG_CLASS } from '../../../../../constants/configurations.constants';
import BordOneToneIcon from '../../../../NudosComponents/BordOneToneIcon/BordOneToneIcon';

import './ConfigClassSelector.scss';

interface ConfigClassSelectorProps {
  configClassIds: CONFIG_CLASS_ID[];
  selectedConfigClassId: CONFIG_CLASS_ID | null;
  onClassSelection: (classId: CONFIG_CLASS_ID) => void;
}

const ConfigClassSelector = ({ configClassIds, selectedConfigClassId, onClassSelection }: ConfigClassSelectorProps) => {
  const formDropdownOptionsCallback = (
    configClassIds: CONFIG_CLASS_ID[],
    clickOptionCallback?: (option: CONFIG_CLASS_ID) => void
  ) => {
    return configClassIds.map(id => {
      const { variantIcon, name } = CONFIG_CLASS[id];
      return (
        <div
          key={id}
          className="optionContainer configClassSelectionOption"
          onClick={() => {
            onClassSelection(id);
            clickOptionCallback?.(id);
          }}
        >
          {variantIcon && <BordOneToneIcon variant={variantIcon} standardSize={14} stroke="#383838" />}
          {name}
        </div>
      );
    });
  };
  const formSelectedOptionUICallback = (selectedClassId: CONFIG_CLASS_ID) => {
    const { variantIcon, name } = CONFIG_CLASS[selectedClassId];
    return (
      <span className="configClassSelectionSelectedOption">
        {variantIcon && <BordOneToneIcon variant={variantIcon} standardSize={14} stroke="#383838" />}
        {name}
      </span>
    );
  };
  const filterBySearchStringCallback = (search: string, configClassIds: CONFIG_CLASS_ID[]) => {
    if (!search) return configClassIds;
    const searchLower = search.toLowerCase();
    return configClassIds.filter(id => CONFIG_CLASS[id].name.toLowerCase().includes(searchLower));
  };

  return (
    <div className="configClassSelectorContainer">
      <label className="configClassSelectorLabel">Configuración</label>
      <NudosSearchbarDropdown
        customClassname="w-full"
        rawOptions={configClassIds}
        formDropdownOptionsCallback={formDropdownOptionsCallback}
        formSelectedOptionUICallback={formSelectedOptionUICallback}
        filterBySearchStringCallback={filterBySearchStringCallback}
        customPlaceholder="Selecciona la configuración"
        currentValue={selectedConfigClassId || undefined}
        isFilled={!!selectedConfigClassId}
        includeMagnifierIcon={false}
      />
    </div>
  );
};

export default ConfigClassSelector;
